const SecondaryBtn = ({ title, css, onClick, type, leftIcon, rightIcon, disabled, tabIndex, titleName }: any) => {
    return (
        <button title={!!titleName ? titleName : ""} type={type} tabIndex={tabIndex} className={`flex items-center justify-center gap-[8px] xlx:gap-[15px] w-fit text-sm bg-primary text-white rounded-[4px] h-[35px] xlx:h-[40px] ${css} disabled:opacity-[0.5] disabled:cursor-not-allowed focus:shadow-[0_0_0_3px_#059db25e] hover:shadow-[0_0_0_3px_#059db25e] disabled:shadow-none disabled:dark:shadow-none`} onClick={onClick} disabled={disabled}>
            {!!leftIcon && leftIcon} {!!title && title}  {!!rightIcon && rightIcon}
        </button>
    );
};

export default SecondaryBtn;